module.exports = {
	"id": "GA",
	"name": "Gabon",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.059296,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.033136,
			"16": 0.006976,
			"17": 0.001744,
			"18": null,
			"19": null,
			"20": 0.003488,
			"21": 0.005232,
			"22": 0.006976,
			"23": 0.001744,
			"24": null,
			"25": 0.010464,
			"26": 0.031392,
			"27": 0.005232,
			"28": 0.005232,
			"29": 0.00872,
			"30": 0.00872,
			"31": 0.012208,
			"32": 0.005232,
			"33": 0.019184,
			"34": 0.029648,
			"35": 0.006976,
			"36": 0.010464,
			"37": 0.00872,
			"38": 0.00872,
			"39": 0.024416,
			"40": 0.006976,
			"41": 0.006976,
			"42": 0.010464,
			"43": 0.094176,
			"44": 0.00872,
			"45": 0.041856,
			"46": 0.020928,
			"47": 0.047088,
			"48": 0.015696,
			"49": 0.54064,
			"50": 0.490064,
			"51": 0.1744,
			"52": 0.528432,
			"53": 4.529168,
			"54": 1.105696,
			"55": 0.012208,
			"56": 0.005232,
			"57": null
		},
		"firefox": {
			"2": 0.003488,
			"3": 0.01744,
			"4": null,
			"5": null,
			"6": 0.010464,
			"7": null,
			"8": 0.001744,
			"9": null,
			"10": 0.013952,
			"11": 0.006976,
			"12": 0.005232,
			"13": null,
			"14": 0.010464,
			"15": 0.003488,
			"16": 0.003488,
			"17": 0.005232,
			"18": 0.022672,
			"19": 0.005232,
			"20": 0.010464,
			"21": 0.036624,
			"22": 0.005232,
			"23": 0.001744,
			"24": null,
			"25": 0.00872,
			"26": 0.005232,
			"27": 0.003488,
			"28": 0.001744,
			"29": 0.012208,
			"30": 0.015696,
			"31": 0.033136,
			"32": 0.047088,
			"33": 0.012208,
			"34": 0.027904,
			"35": 0.074992,
			"36": 0.031392,
			"37": 0.047088,
			"38": 0.015696,
			"39": 0.057552,
			"40": 0.045344,
			"41": 0.102896,
			"42": 0.022672,
			"43": 0.371472,
			"44": 0.038368,
			"45": 0.054064,
			"46": 0.068016,
			"47": 0.530176,
			"48": 0.491808,
			"49": 2.490432,
			"50": 0.085456,
			"51": 0.027904,
			"52": 0.003488,
			"3.5": 0.003488,
			"3.6": 0.02616
		},
		"opera": {
			"9": null,
			"11": 0.003488,
			"12": 0.015696,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.003488,
			"19": 0.005232,
			"20": null,
			"21": null,
			"22": 0.010464,
			"23": null,
			"24": 0.005232,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.003488,
			"29": null,
			"30": 0.132544,
			"31": null,
			"32": 0.005232,
			"33": 0.006976,
			"34": null,
			"35": 0.005232,
			"36": 0.00872,
			"37": 0.143008,
			"38": 0.019184,
			"39": 0.029648,
			"40": 0.23544,
			"41": 0.027904,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.001744,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.006976,
			"12.1": 0.013952
		},
		"safari": {
			"0": null,
			"4": 0.012208,
			"5": 0.005232,
			"6": 0.003488,
			"7": 0.003488,
			"8": 0.062784,
			"9": 0.036624,
			"10": 0.169168,
			"3.1": null,
			"3.2": null,
			"5.1": 0.019184,
			"6.1": 0.003488,
			"7.1": 0.038368,
			"9.1": 0.181376
		},
		"ios_saf": {
			"8": 0,
			"10": 0.744978544546,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0200763097419,
			"8.1-8.4": 0.037090131557,
			"9.0-9.2": 0.0176943746878,
			"9.3": 0.269952639467
		},
		"android": {
			"3": 0,
			"4": 0.144256,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.018032,
			"4.1": 0.520352,
			"4.2-4.3": 1.30088,
			"4.4": 2.983008,
			"4.4.3-4.4.4": 3.008768
		},
		"ie": {
			"6": 0.00175592886457,
			"7": 0.00526778659371,
			"8": 0.166813242134,
			"9": 0.0579456525308,
			"10": 0.10359980301,
			"11": 0.941177871409,
			"5.5": 0.00702371545828
		},
		"op_mob": {
			"0": 3.39848357073,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0944023214092
		},
		"edge": {
			"12": 0.088944,
			"13": 0.172656,
			"14": 0.106384
		},
		"ie_mob": {
			"10": 0.503034591549,
			"11": 2.04806940845
		},
		"bb": {
			"7": 0.584112,
			"10": null
		},
		"samsung": {
			"0": 3.706944
		},
		"and_uc": {
			"0": 1.882368
		},
		"op_mini": {
			"0": 45.7871781079
		},
		"and_chr": {
			"0": 13.563152
		},
		"and_ff": {
			"0": 0.016512
		}
	},
	"total": 96.392432
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GA.json
 ** module id = 524
 ** module chunks = 0
 **/